import FormHeading from "../../components/formik/elements/FormHeading";
import React, {useEffect, useState} from "react";
import * as statisticsApi from "../../api/statisticsApi";
import * as attendeeApi from "../../api/attendeeApi";
import * as commonsApi from "../../api/commonsApi";
import Select from "../../components/formik/elements/Select";
import ListGroup from "../../components/formik/elements/ListGroup";
import CompaniesTable from "./table/CompaniesTable";
import ErrorAlert from "../error/ErrorAlert";

const StatisticsAverage = () => {
    const [listSector, setListSector] = useState([])
    const [listTargetCountries, setListTargetCountries] = useState([])
    const [ListAverage, setListAverage] = useState([])
    const [listIsExport] = useState(["Visi", "Taip", "Ne", "Nenurodyta"])
    const [isExporter, setIsExporter] = useState(null)
    const [companyMaturityType, setCompanyMaturityTypes] = useState(null)

    const [sectorIndx, setSectorIndx] = useState(0)
    const [targetCountriesIndx, setTargetCountriesIndx] = useState([0])
    const [companyMaturityTypeIndex, setCompanyMaturityTypesIndex] = useState(null)

    const [dataTable, setDataTable] = useState([])
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(100); // Default page size
    const [attendeePage, setAttendeePage] = useState({
        attendees: [],
        activePage: 1,
        totalPages: null,
        itemsCountPerPage: 100,
        totalItemsCount: null
    })
    const [error, setError] = useState(null)

    //company stats
    const [stats, setStats] = useState({});
    const [selectedYear, setSelectedYear] = useState("");
    const [companyCount, setCompanyCount] = useState("");

    const [allFinishedCompanies, setAllFinishedCompanies] = useState(0)
    const [allRegisteredCompanies, setAllRegisteredCompanies] = useState(0)

    const fetchAttendeePage = () => {
        statisticsApi.fetchSectorlist()
            .then(({ data }) => setListSector(Object.values(data)))
            .catch((error) => setError(error))
    }

    const fetchTargetCountries = () => {
        attendeeApi.fetchTargetCountries()
            .then(({ data }) => setListTargetCountries(Object.values(data)))
            .catch((error) => setError(error))
    }

    const fetchMaturityTypes = () => {
        commonsApi.fetchMaturityTypes()
        .then(({ data }) => setCompanyMaturityTypes(Object.values(data)))
        .catch((error) => setError(error));
    }

    const fetchAllFinishedCompanies = () => {
        attendeeApi.fetchAllFinishedAttendees()
        .then(({ data }) => {
            if (data === null) {
                setError("Unable to fetch all finished companies data");
            }
            setAllFinishedCompanies(data);
        })
        .catch((error) => setError(error));
    };

    const fetchAllRegisteredCompanies = () => {
        attendeeApi.fetchAllRegisteredAttendees()
        .then(({ data }) => {
            if (data === null) {
                setError("Unable to fetch all registered companies data");
            }
            setAllRegisteredCompanies(data);
        })
        .catch((error) => setError(error));
    };

    const fetchSectorType = () => {
        statisticsApi.fetchSectorAverage(
            sectorIndx, targetCountriesIndx, isExporter, companyMaturityTypeIndex)
            .then(({ data }) => setListAverage(data))
            .catch((error) => setError(error))
    }

    const fetchSector = (page = 0, pageSize = 100) => {
        statisticsApi.fetchSector(
            sectorIndx, targetCountriesIndx, isExporter, companyMaturityTypeIndex,
            page, pageSize)
            .then(({ data }) => {
                const tableData = data?.content?.map(i => {
                    let newRatingResults = []
                    i?.surveyDiagnostics?.detailedEstimates?.map(k => {
                        k.ratingResults?.map(fff => {
                            newRatingResults.push({...fff, ratingTotalEstimate: Math.round(fff?.ratingTotalEstimate)})
                        })

                    })
                    return {
                        ...i, ...newRatingResults
                    }
                });
                setDataTable(tableData)
                setCurrentPage(data.number + 1);       // Current page index
                setTotalPages(data.totalPages);    // Total pages
                setTotalItems(data.totalElements); // Total records count
                setItemsPerPage(data.size); //pageSize

            })
        .catch(error => setError(error))
    }

    const fetchFinishedCompaniesByYear = () => {
        attendeeApi.fetchYearlyFinishedAttendees()
        .then(({data}) => {
            const sortedYears = Object.keys(data).sort((a, b) => parseInt(b) - parseInt(a));
            setStats(data);
            const defaultYear = sortedYears[0];
            setSelectedYear(defaultYear);
            setCompanyCount(data[defaultYear]);
        })
        .catch((error) => setError(error));
    };

    useEffect(() => {
        fetchAttendeePage();
        fetchTargetCountries();
        fetchFinishedCompaniesByYear();
        fetchMaturityTypes();
        fetchAllFinishedCompanies();
        fetchAllRegisteredCompanies();
    }, [])

    useEffect(() => {
        fetchSectorType()
        setActivePage(1, attendeePage.itemsCountPerPage) //leaving same page size, but changing filter will get to first page
    }, [sectorIndx, targetCountriesIndx, isExporter, companyMaturityTypeIndex])

    const setActivePage = (pageNumber, size) => {
        setAttendeePage(prevState => ({
            ...prevState,
            activePage: pageNumber,
            itemsCountPerPage: size
        }));
        fetchSector(pageNumber - 1, size);
    };

    const handleTableChange = (type, { page, sizePerPage }) => {
        setActivePage(page, sizePerPage);
    };

    const handleYearChange = (event) => {
        const year = event.target.value;
        setSelectedYear(year);
        setCompanyCount(stats[year]);
    };

    const onChangeSector = e => {
        setSectorIndx(+e.target.value);
    }

    const onChangeTargetCountries = e => {
        const selectedValues = Array.isArray(e) ? e.map(item => item.value) : [e.target.value];
        setTargetCountriesIndx(selectedValues);
    }

    const onChangeIsExporter = e => {
        const value = e.target.value;

        switch (value) {
            case "0":
                setIsExporter(null);
                break;
            case "1":
                setIsExporter([true]);
                break;
            case "2":
                setIsExporter([false]);
                break;
            case "3":
                setIsExporter([null]);
                break;
            default:
                setIsExporter(null); // Fallback to "Visi"
        }
    }

    const onChangeMaturityType = e => {
        const selectedValues = Array.isArray(e) ? e.map(item => item.value) : [e.target.value];
        setCompanyMaturityTypesIndex(selectedValues);
    }

    const titleTable = [
        'Įmonė', 'Sektorius', "Branda", 'Bazinės įmonės pasirengimas', 'Tikslinių rinkų ir segmentų pažinimas', 'Produktų / paslaugų paruošimas eksportui', 'Rinkodara ir viešieji ryšiai', 'Eksporto pardavimų proceso valdymas ir įgūdžiai', 'Pasiryžimas plėsti eksportą ir veiksmų planavimas', 'Eksporto kanalų diversifikavimas', 'Eksporto dalis apyvartoje', 'Eksporto istorija', 'Eksporto geografija', 'Eksporto apimtys',
    ]

    return (
        <div className="container-fluid w-90">
            {error && <ErrorAlert error={error}/>}
            {!error &&
            <>
                <FormHeading text="Įmonių statistika"/>

                <div>
                    <label className="fw-bold" style={{ marginRight: "10px" }}>Užsiregistravusių įmonių:</label>
                    <input type="text" value={allRegisteredCompanies} readOnly className="form-control ms-2 text-center"
                           style={{ width: "50px", minWidth: "50px", maxWidth: "60px", padding: "5px" }}
                    /> <label className="fw-bold" style={{ marginRight: "10px" }}>Įmonių, atlikusių testą:</label>
                    <input type="text" value={allFinishedCompanies} readOnly className="form-control ms-2 text-center"
                           style={{ width: "50px", minWidth: "50px", maxWidth: "60px", padding: "5px" }}
                    />
                </div>
                {/*Section for Yearly Company Count*/}
                <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                    <div>
                        <label className="fw-bold" style={{ marginRight: "10px" }}>Įmonių, </label>
                        <select className="form-select ms-2 w-auto d-inline-block" value={selectedYear} onChange={handleYearChange}>
                            {Object.keys(stats).map((year) => (
                                <option key={year} value={year}>{year}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="fw-bold" style={{ marginRight: "10px" }}>metais atlikusių testą:</label>
                        <input type="text" value={companyCount} readOnly className="form-control ms-2 text-center"
                               style={{ width: "50px", minWidth: "50px", maxWidth: "60px", padding: "5px" }}
                        />
                    </div>
                </div>
                {/*Section for Yearly Company Count End*/}

                <label className="fw-bold" style={{ marginRight: "10px" }}>Sektorius</label>
                <Select items={listSector} onChange={onChangeSector} />
                <label className="fw-bold" style={{ marginLeft: "10px", marginRight: "10px" }}>Prioritetinė rinka</label>
                <Select items={listTargetCountries} onChange={onChangeTargetCountries} />
                <label className="fw-bold" style={{ marginLeft: "10px", marginRight: "10px" }}>Ar vykdo eksportą</label>
                <Select items={listIsExport} onChange={onChangeIsExporter} />
                <label className="fw-bold" style={{ marginLeft: "10px", marginRight: "10px" }}>Eksporto brandos tipas</label>
                <Select items={companyMaturityType} onChange={onChangeMaturityType} />

                <ListGroup items={ListAverage} />
                {attendeePage.attendees.length !== 0
                    ? <p>Registruotų įmonių sąrašas tuščias.</p>
                    : <CompaniesTable
                        data={dataTable}
                        page={attendeePage.activePage}
                        sizePerPage={attendeePage.itemsCountPerPage}
                        totalSize={totalItems}
                        onTableChange={handleTableChange}
                        titleTable={titleTable}
                    />
                }
            </>
            }
        </div>
    );
}

export default StatisticsAverage;